

import React, { useState } from 'react';
import { Select, DatePicker, Space } from 'antd';
import dayjs from 'dayjs';
const { RangePicker } = DatePicker;

const SelectPeriod = (props) => {
  const { onChange, defaultValue } = props;
  const [showRangePicker, setShowRangePicker] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);

  const periodes = [
    { label: "Aujourd'hui", value: 1 },
    { label: "Hier", value: 2 },
    { label: "Cette Semaine", value: 3 },
    { label: "Semaine Derniere", value: 4 },
    { label: "Ce Mois-ci", value: 5 },
    { label: "Mois Dernier", value: 6 },
    { label: "Cette Année", value: 7 },
    { label: "Année Derniere", value: 8 },
    { label: "Date à Date", value: 9 },
  ];

  const handleSelectChange = (value) => {
    setShowRangePicker(value === 9);
    if (value !== 9) {
      onChange(value, null);
    }
  };

  const handleRangeChange = (dates, dateStrings) => {
    setSelectedDates(dates);
    onChange(9, dateStrings);
  };

  const disabledDate = (current) => {
    return current && current > dayjs().endOf('day');
  };

  return (
    <div>
      <Space>
        <Select
          bordered={false}
          style={{ width: 200, borderBottom: '2px solid #0d0c0c' }}
          placeholder="Sélectionner..."
          options={periodes}
          onChange={handleSelectChange}
          defaultValue={defaultValue}
        />
        {showRangePicker && (
          <RangePicker
            onChange={handleRangeChange}
            disabledDate={disabledDate}
            style={{ border: '2px solid #0d0c0c', width: 300 }}
            value={selectedDates}
          />
        )}
      </Space>
    </div>
  );
};

export default SelectPeriod;
